import React, { useEffect } from 'react';

import { Divider, Box, CircularProgress } from '@material-ui/core';
import { Button, Modal } from 'antd';
import * as moment from 'moment';
import { Link } from 'react-router-dom';
import DatePickerUi from './DatePicker';
import { useRouteMatch, useParams, useLocation } from 'react-router-dom';
import qs from 'query-string';

import TransactionHistoryProfile from '../../../Service/TransactionHistoryProfile';

import { AddIcon, DeductIcon } from './icons';

import './index.css';
import MobileFooter from '../../Common/Profile/MobileFooter';

function useQuery() {
	const { search } = useLocation();

	return React.useMemo(() => new URLSearchParams(search), [search]);
}

const TransactionHistory = () => {
	const [showModal, setShowModal] = React.useState(false);
	const [loading, setLoading] = React.useState(false);
	const [data, setData] = React.useState([]);
	const [totalItems, setTotalItems] = React.useState(0);
	const [activeNext, setActiveNex] = React.useState(true);
	const [activePrev, setActivePrev] = React.useState(false);
	const [sending, setSending] = React.useState(false);
	const [state, setState] = React.useState({
		_fromDate: null,
		_toDate: null,
		message: ''
	});

	const query = useQuery();

	const [currentUser, setCurrentUser] = React.useState({ username: '', email: '' });
	const match = useRouteMatch('/admin/transactions/:id');
	let { id } = useParams();

	const [limit, _] = React.useState(10);

	const [page, setPage] = React.useState(1);

	const onChange = (_date, dateStrings) => {
		setState({ _fromDate: dateStrings[0], _toDate: dateStrings[1] });
	};

	const getTransactionHistory = async () => {
		let offset = 0;

		let startDate = '';
		let endDate = '';
		setLoading(true);

		try {
			const queryParams = `?startDate=${startDate}&endDate=${endDate}&limit=${limit}&offset=${offset}&page=${page}`;

			if (match && id) {
				const response = await TransactionHistoryProfile.getTransactionByUserId(id, queryParams);
				if (response && response?.result?.length > 0) {
					setData(response.result);

					setTotalItems(response.count);
					setCurrentUser({ username: response.fullname, email: response.current_user_email });
				}
			} else {
				const response = await TransactionHistoryProfile.getAllTransactionByUser(queryParams);

				if (response && response?.result?.length > 0) {
					setData(response.result);

					setTotalItems(response.count);
				}
			}

			setLoading(false);
		} catch (error) {
			setLoading(false);
			console.log(error.message);
		}
	};

	const incrementPage = () => {
		if (!(data?.length > 0) || page === Math.ceil(totalItems / limit)) return;
		setActiveNex(true);
		setActivePrev(false);

		setPage(prev => prev + 1);
	};

	const decrementPage = () => {
		setActivePrev(true);
		setActiveNex(false);

		setPage(prev => prev - 1);
	};

	const getCurrentUser = () => {
		if (match && id) return currentUser.email;
		const user = JSON.parse(localStorage.getItem('CURRENT_USER_INFO')).profile;

		return user?.email;
	};

	const getQueryParams = () => {
		const { globalSearch } = qs.parse(window.location.search);
		return globalSearch;
	};

	const sendReport = async () => {
		if (state._fromDate === null || state._toDate === null) return;
		if (state.message) {
			setShowModal(false);
		}
		setSending(true);
		try {
			const body = {
				startDate: state._fromDate,
				endDate: state._toDate,
				email: getCurrentUser()
			};

			const res = await TransactionHistoryProfile.sendReport(body);

			if (res) {
				setState({ message: res.data });
			}
			setSending(false);
		} catch (e) {
			console.log(e);
		}
	};

	useEffect(() => {
		getTransactionHistory();

		console.log(getQueryParams());
	}, [page]);

	function removeDecimalZeros(price) {
		if (typeof price !== 'number') {
			price = parseFloat(price);
			if (isNaN(price)) {
				throw new TypeError('Input must be a number or a string representing a number');
			}
		}
		let formattedPrice = price % 1 === 0 ? price.toFixed(0) : price.toFixed(2);
		return parseFloat(formattedPrice).toLocaleString();
	}

	function convertToPhilippinesTime(date) {
		const utcDate = moment.utc(date).locale('en');

		return utcDate.format('MMMM D, YYYY | h:mm A');
	}

	return (
		<div className={`transaction_container ${match && id ? 'admin' : 'profile'}`}>
			<h3 className="heading">Transactions Within the Last 3 Months</h3>
			{match && id && <h4 style={{ fontWeight: 'bold' }}>{currentUser.username}</h4>}
			{match && id && <Divider className="mobile_divider transaction_divider" />}

			{data?.length > 0 ? (
				data?.map(item => (
					<div className="transaction_list" key={item.id}>
						<div className="transaction_detail_container">
							<img
								src={
									item.transaction_type === 'Topup' ||
									(item.transaction_type === 'Transfer' &&
										item.destination_wallet_email === getCurrentUser())
										? AddIcon
										: DeductIcon
								}
								alt="addIcon"
								className="arrow_icon"
							/>
							<div className="transaction_detail">
								{(item.transaction_type === 'Topup' || item.transaction_type === 'Cashout') && (
									<p className="transaction_user">
										{item.transaction_type} via {item.bank}
									</p>
								)}

								{item.transaction_type === 'Transfer' &&
									item.type === 'PRINCIPAL' &&
									item.destination_wallet_email === getCurrentUser() && (
										<p className="transaction_user">
											Loan Fund Transfer from {item.source_wallet || 'Anonymous User'}
										</p>
									)}

								{item.transaction_type === 'Transfer' &&
									item.type === 'EMI' &&
									item.destination_wallet_email === getCurrentUser() && (
										<p className="transaction_user">
											Payment from {item.source_wallet || 'Anonymous User'}
										</p>
									)}

								{item.transaction_type === 'Transfer' &&
									item.type === 'PRINCIPAL' &&
									item.destination_wallet_email !== getCurrentUser() && (
										<p className="transaction_user">
											Loan Fund Transfer to {item.destination_wallet || 'Anonymous User'}
										</p>
									)}

								{item.transaction_type === 'Transfer' &&
									item.type === 'EMI' &&
									item.destination_wallet_email !== getCurrentUser() && (
										<p className="transaction_user">
											Payment to {item.destination_wallet || 'Anonymous User'}
										</p>
									)}

								<p className="transaction_date">{convertToPhilippinesTime(item.transaction_date)}</p>
								{item.loan_id && (
									<p className="transaction_ref">
										Ref No: {item.ref_number} &#124; Loan ID:{' '}
										<Link
											className="transaction_ref_link"
											to={`/amortization-table/${item.loan_id}`}
											target="_blank"
											rel="noopener noreferrer">
											LA0{item.loan_id}
										</Link>
									</p>
								)}
								{!item.loan_id && (
									<p className="transaction_ref">
										Ref No:{' '}
										{item.transaction_type === 'Cashout'
											? item.ref_number?.split('-')[0]?.toUpperCase()
											: item.ref_number?.toUpperCase()}
									</p>
								)}
							</div>

							<span
								className={`transaction_amount ${
									(item.transaction_type === 'Transfer' &&
										item.destination_wallet_email === getCurrentUser()) ||
									item.transaction_type === 'Topup'
										? ''
										: 'deduct'
								}  `}>
								{(item.transaction_type === 'Transfer' &&
									item.destination_wallet_email === getCurrentUser()) ||
								item.transaction_type === 'Topup'
									? `+ PHP ${
											item.type === 'EMI' && item.transfer_emi_amount
												? removeDecimalZeros(item.transfer_emi_amount)
												: item.type === 'PRINCIPAL' && item.transfer_principal_amount
												? removeDecimalZeros(item.transfer_principal_amount)
												: removeDecimalZeros(item.receivable_amount) || 0
									  }`
									: `- PHP ${
											item.type === 'EMI' && item.transfer_emi_amount
												? removeDecimalZeros(
														Number(item.transfer_emi_amount) + Number(item.transaction_fee)
												  )
												: item.type === 'PRINCIPAL' && item.transfer_principal_amount
												? removeDecimalZeros(
														Number(item.transfer_principal_amount) +
															Number(item.principal_service_fee)
												  )
												: removeDecimalZeros(item.receivable_amount) || 0
									  }`}
							</span>
						</div>
						<Divider className="mobile_divider transaction_divider_hover" />
						<Divider className="mobile_divider transaction_divider" />
					</div>
				))
			) : loading ? (
				<p style={{ textAlign: 'center' }}> Searching...</p>
			) : (
				<p style={{ textAlign: 'center' }}>No data found</p>
			)}
			{loading && (
				<Box style={{ display: 'flex', justifyContent: 'center' }}>
					<CircularProgress />
				</Box>
			)}
			<div className="transaction_footer">
				<p style={{ textAlign: 'center' }}>
					{!(data?.length > 0) ? null : `Page ${page} of ${Math.ceil(totalItems / limit)} `}
				</p>

				<div style={{ display: 'flex', flexDirection: 'row-reverse', gap: '20px' }}>
					{!(data?.length > 0) ? null : (
						<>
							<button
								className={`request_button next ${activeNext || page <= 1 ? 'active' : ''} ${
									page === Math.ceil(totalItems / limit) ? 'disabled' : ''
								}`}
								disabled={page === Math.ceil(totalItems / limit)}
								onClick={incrementPage}>
								Next
							</button>
							<button
								className={`request_button prev ${activePrev ? 'active' : ''} ${
									page <= 1 ? 'disabled' : ''
								}`}
								disabled={page <= 1}
								onClick={decrementPage}>
								Prev
							</button>
						</>
					)}
				</div>

				{match ? null : (
					<>
						<p>Need to view more? Please submit a request. We will send the</p>
						<p>Transaction History to your email.</p>
						<button
							className={`request_button ${!(data?.length > 0) ? 'disabled' : ''}`}
							disabled={!(data?.length > 0)}
							onClick={() => {
								setShowModal(true);
								setState({ message: '', _fromDate: null, _toDate: null });
							}}>
							Request Transaction History
						</button>
					</>
				)}
			</div>
			<Modal
				className="date_picker_modal"
				title={<p style={{ fontWeight: 'bold' }}>Select Date Range</p>}
				open={showModal}
				footer={
					<div className="transaction-history-modal-footer">
						<Button type="primary" className="btn-send-report" onClick={sendReport}>
							{sending ? 'Sending...' : state.message ? 'Ok' : 'Send To Email'}
						</Button>
					</div>
				}
				onCancel={() => setShowModal(false)}>
				<DatePickerUi onChange={onChange} />{' '}
				{state.message && (
					<p
						className={`${
							state.message.includes('Email Sent Successfully! Please check your inbox.')
								? `success-message`
								: 'error-message'
						}`}>
						{state.message}
					</p>
				)}
			</Modal>
			{match && id && (
				<MobileFooter
					disclaimer={false}
					onClick={() => (window.location.href = `/admin?globalSearch=${query.get('globalSearch')}&page=0`)}
				/>
			)}
		</div>
	);
};

export default TransactionHistory;
